import React from 'react';
import Modal from '@/components/shared/Modal/Modal';
import Button from '@/components/shared/Button/Button';

export function TourWelcomeModal(props: {
  isOpen: boolean;
  title: string;
  description: string;
  onClose: () => void;
  onStart: () => void;
}) {
  const { isOpen, title, description, onClose, onStart } = props;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      closeOnOverlayClick={false}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Close Guide
          </Button>
          <Button variant="primary" onClick={onStart}>
            Start Tour
          </Button>
        </>
      }
      size="md"
      className="border border-emerald-400/40 shadow-[0_0_0_1px_rgba(16,185,129,0.25),0_0_30px_rgba(16,185,129,0.25)]"
    >
      <p className="text-white/80 text-sm leading-6">{description}</p>
    </Modal>
  );
}

